module.exports = __webpack_public_path__ + "img/it.2063c347.svg";